import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { GlobalConfig, UserNotification } from '../../models/global-config';
import { GlobalConfigService } from '../../services/global-config.service';
import { NgForm } from '@angular/forms';
import { ToastMessageService } from '../../../shared/services/toast-message.service';
import { IDeactivateComponent } from '../../../authentication/i-deactivate/i-deactivate.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-admin-settings',
    templateUrl: './admin-settings.component.html',
    styleUrls: ['./admin-settings.component.scss'],
    standalone: false,
})
export class AdminSettingsComponent implements OnInit, IDeactivateComponent {
    @ViewChild('notificationForm') notificationForm?: NgForm;

    globalConfig: GlobalConfig;
    notification = {
        displayUserNotification: false,
        germanText: '',
        englishText: '',
    };
    readonly TOAST_MESSAGE_DELAY = { delay: 2000 };

    constructor(
        private globalConfigService: GlobalConfigService,
        private messageService: ToastMessageService,
        private translateService: TranslateService
    ) {}

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent): void {
        if (this.hasUnsavedChanges()) {
            event.preventDefault();
        }
    }

    hasUnsavedChanges(): boolean {
        return this.notificationForm?.dirty ?? false;
    }

    canExit(): boolean {
        if (this.hasUnsavedChanges()) {
            return window.confirm(
                this.translateService.instant(
                    'admin.components.appSettings.userNotification.unsavedChangesWarning'
                )
            );
        }
        return true;
    }

    ngOnInit(): void {
        this.globalConfigService.getConfig().subscribe({
            next: (data) => {
                this.globalConfig = data;
                this.notification.displayUserNotification =
                    this.globalConfig.displayUserNotification;
                this.notification.germanText =
                    this.globalConfig.userNotification?.de ?? '';
                this.notification.englishText =
                    this.globalConfig.userNotification?.en ?? '';
            },
        });
    }

    onSaveButtonPressed() {
        this.globalConfig.displayUserNotification =
            this.notification.displayUserNotification;
        const userNotification: UserNotification = {
            de: this.notification.germanText,
            en: this.notification.englishText,
        };
        this.globalConfig.userNotification = userNotification;
        this.globalConfigService.updateConfig(this.globalConfig).subscribe({
            next: (g) => {
                this.globalConfig = g;
                this.messageService.showTranslatedSuccessMsg(
                    'admin.components.appSettings.userNotification.saveChangesSucess',
                    this.TOAST_MESSAGE_DELAY
                );
                this.notificationForm?.resetForm(this.notification);
            },
            error: (err) => {
                if (err.status < 500) {
                    // backend denied update
                    this.messageService.showTranslatedErrorMsg(
                        'admin.components.appSettings.userNotification.saveChangesFailure',
                        this.TOAST_MESSAGE_DELAY
                    );
                } else {
                    // other errors
                    this.messageService.showTranslatedErrorMsg(
                        'admin.components.appSettings.userNotification.saveChangesError',
                        this.TOAST_MESSAGE_DELAY
                    );
                }
            },
        });
    }
}
